var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "membership-modal" }, [
    _c("div", { staticClass: "row mb-2" }, [
      _c(
        "div",
        {
          staticClass: "col d-flex justify-content-between align-items-center"
        },
        [
          _c("h4", {}, [_vm._v("Mod24 Membership includes")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-close p-0",
              on: {
                click: function($event) {
                  _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "mod-icon-close opacity-50" })]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-includes" }, [
      _c("div", { staticClass: "promo-features mt-3" }, [
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ $49 Move discount")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ Free TV insurance $100 worth")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ 1 Month free storage")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ $50 off car shipping")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ $200 Cross country move discount")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ 20% off from packing supplies")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ Booking priority")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _vm._v("✓ VIP concierge service")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7c5d8e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7c5d8e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MembershipPerks.vue
// module id = null
// module chunks = 